import { Box, Button, colors } from "@biblioteksentralen/react";
import { ComponentProps } from "react";

export const SubjectBadge = (props: ComponentProps<typeof Button>) => (
  <Button
    as={Box}
    size="sm"
    textDecoration="none"
    fontWeight="normal"
    padding="0.25rem 0.5rem"
    height="unset"
    lineHeight="1"
    borderRadius="3xl"
    background={colors.grey10}
    textColor={colors.black}
    transition="filter 0.25s ease"
    _hover={{ filter: "brightness(0.9)" }}
    whiteSpace="wrap"
    {...props}
  />
);
